/* eslint-disable no-undef, strict, no-console, no-unused-vars, eqeqeq */
class HelpWidget {
	constructor(_options) {
		let _that = this;
		let parent = document.querySelector('#help_center_widget');
		let widget_defaults = {
			parent: document.querySelector('#help_center_widget'),
			page_name: '',
			widget_form_holder : parent.querySelector('.widget_form_holder'),
			button_help: parent.querySelector('#hw_show_form'),
			search_form: parent.querySelector('.widget_serch_form'),
			search_input: parent.querySelector('#search_input'),
			widget_go_search: parent.querySelector('#go_search'),
			answer_holder: parent.querySelector('#answer_holder'),
			question: parent.querySelectorAll('.list-group-item'),
			go_to_helpcenter: parent.querySelector('#go_to_helpcenter'),
			contact_holder : parent.querySelector('#contact_holder'),
			back_button: parent.querySelector('.back_button'),
			chat_button: parent.querySelector('#hw_chat'),
			search_section: parent.querySelector('#search_section'),
			chat_agents_online: false,
			idle_time: 180000,
			idle_time_amount : 180000,
			last_search_string : 'default_page_questions',
			click_number: 0
		};
		_that.options = Object.assign(widget_defaults, _options);
		_that.idle = setInterval(() => {
			_that.options.idle_time-= 1000;
			if (_that.options.idle_time < 0) {
				$('.close_widget').trigger('click');
			}
		}, 1000);

		let c = document.createElement('div');
		c.classList.add('text-center', 'p-10');
		let close_button = document.createElement('button');
		close_button.classList.add('close_widget', 'btn', 'btn-primary', 'mx-15', 'mb-20');
		close_button.appendChild(document.createTextNode(s.it('CLOSE', {})));
		c.appendChild(close_button);

		_that.prepare_form();
		_that.bindEvents();
		_that.bindSearchSectionEvents();
	}

	bindQuestionEvents() {
		let _that = this;
		let elements = {
			back_button:  _that.options.parent.querySelector('.back_button'),
			questions:  _that.options.parent.querySelectorAll('.list-group-item'),
			go_to_helpcenter: _that.options.parent.querySelector('#go_to_helpcenter')
		}
		elements.questions.forEach(question => {
			if (!question.classList.contains('active')) {
				question.addEventListener('click', () => {
					let question_id = question.dataset.id;
					_that.log_click(question_id);
					_that.add_local_storage('question_id', question_id);
					elements.go_to_helpcenter.setAttribute('href', s.url('/help_center', {'qid': question_id}));
					if (_that.options.chat_agents_online) {
						let chat_button_existing = document.querySelector('#hw_chat');
						if (chat_button_existing && !chat_button_existing.classList.contains('not-visible')) {
							chat_button_existing.parentNode.removeChild(chat_button_existing);
						}
						let chat_button = document.querySelector('#hw_chat');
						if (chat_button ===  null) {
							let chat_button = document.createElement('a');
							chat_button.classList.add('btn', 'btn-primary', 'btn-sm', 'pull-left');
							chat_button.setAttribute('id', 'hw_chat');
							chat_button.appendChild(document.createTextNode(s.it('LIVE_CHAT', {})));
							_that.options.parent.querySelector('#contact_holder').appendChild(chat_button);
							_that.bindChatEvents();
						}
					}
					_that.options.parent.querySelector('#answer_holder').innerHTML = '';
					_that.options.parent.querySelector('#answer_holder').appendChild(_that.generate_answer(question_id));
				});
			}
		});
	}

	bindSearchSectionEvents() {
		let _that = this;
		_that.options.parent.querySelector('#search_input').addEventListener('keyup', (e) => {
			if (e.keyCode === 13) {
				let spinner = _that.getSpinner();
				let searched_string = _that.options.parent.querySelector('#search_input').value;
				if (searched_string !== '') {
					_that.options.parent.querySelector('#go_search img').src = s.url('/images/spinner.svg');
					_that.search(searched_string);
				}
			}
		});
		_that.options.widget_go_search.addEventListener('click', (e) => {
			e.preventDefault();
			let spinner = _that.getSpinner();
			let search_string = _that.options.search_input.value;
			if (search_string !== '') {
				_that.options.parent.querySelector('#go_search img').src = s.url('/images/spinner.svg')
				_that.search(search_string);
			}
		});
	}

	bindChatEvents() {
		let _that = this;
		let chat_button = _that.options.parent.querySelector('#hw_chat');
		if (chat_button) {
			chat_button.addEventListener('click', (e) => {
				e.preventDefault();
				let existing_form = document.querySelector('.hw_form_contact');
				if (existing_form) {
					existing_form.parentNode.removeChild(existing_form);
				}
				let form = _that.options.parent.querySelector('#form_contact').cloneNode(true);
				form.id = null;
				form.classList.add('hw_form_contact');
				_that.options.parent.querySelector('.widget_form_holder').innerHTML = '';
				form.classList.remove('d-none');
				_that.options.widget_form_holder.appendChild(form);
				let chat_backs = _that.options.parent.querySelectorAll('.chat_back');
				chat_backs.forEach((chat_back) => {
					chat_back.addEventListener('click', () => {
						let _that = this;
						_that.go_back();
					});
				});

				let input_contact = _that.options.parent.querySelector('input[name=contact_options]:checked');
				if (input_contact === 'chat_with_us') {
					let w = window.open('about:blank', 'chat_window', 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=500,height=700');
					form.target = 'chat_window';
				} else {
					form.target = '_self';
				}
			});
		}
	}

	bindEvents() {
		let _that = this;
		_that.options.widget_form_holder.addEventListener('click', () => {
			let _that = this;
			_that.options.idle_time = _that.options.idle_time_amount;
		});
		let toggle_state = _that.options.parent.querySelector('#hw_toggle_state');
		toggle_state.addEventListener('click', () => {
			toggle_state.classList.add('spin');
			setTimeout(() => {}, 500);
			if (toggle_state.classList.contains('help_widget_active')) {
				_that.close_widget();
				toggle_state.classList.remove('help_widget_active');
				toggle_state.querySelector('.question-mark').classList.remove('close_button');
				// toggle_state.querySelector('.question-mark').innerHTML = '?';
			} else {
				_that.show_widget();
				toggle_state.classList.add('help_widget_active');
				toggle_state.querySelector('.question-mark').classList.add('close_button');
				// toggle_state.querySelector('.question-mark').innerHTML = 'x';
			}
		});
	}

	generate_answer(question_id) {
		let _that = this;
		let data = window.localStorage.getItem('questions');
		let decoded_data = JSON.parse(data);
		let selected_question = [];
		decoded_data.forEach(function (question) {
			if (parseInt(question.id) === parseInt(question_id)) {
				selected_question = question;
			}
		});

		let holder = document.createElement('div');
		let question_header = document.createElement('div');
		let question_body = document.createElement('div');
		let question_footer = document.createElement('div');
		let back_button = document.createElement('a');
		holder.classList.add('answer_outer_holder');
		question_header.classList.add('list-group-item', 'active');
		question_header.innerHTML = selected_question.question;
		question_body.classList.add('answer');
		question_body.innerHTML = selected_question.answer;
		back_button.classList.add('back_button', 'my-15', 'd-inline-block');
		back_button.href = '#';
		back_button.innerText = "« " + s.it('BACK', {});
		question_footer.appendChild(back_button);
		question_footer.classList.add('question_footer');
		holder.appendChild(question_header);
		holder.appendChild(question_body);
		holder.appendChild(question_footer);
		back_button.addEventListener('click', (e) => {
			e.preventDefault();
			_that.go_back();
		});
		return holder;
	}

	generate_question_list(data) {
		let _that = this;
		_that.options.answer_holder.innerHTML = '';
		let response = document.createElement('ul');
		response.classList.add('list-group');
		data.forEach(function (answer) {
			let li = document.createElement('li');
			li.classList.add('list-group-item', 'cursor_pointer', 'hover', 'border-bottom');
			li.setAttribute('data-id', answer.id);
			let link = document.createElement('a');
			link.innerText = answer.question;
			li.appendChild(link);
			response.appendChild(li);
		});
		return response;
	}

	generate_search_section() {
		let _that = this;
		let form_group = document.createElement('div');
		let search_section = document.createElement('div');
		let search_input = document.createElement('input');
		let svg_holder = document.createElement('div');
		let search_button = document.createElement('button');
		let search_svg = document.createElement('img');
		search_svg.src = s.url('/images/svg_icons/Icon-search.svg');
		search_input.classList.add('form-control', 'input-lg');
		search_input.placeholder = s.it('I_NEED_HELP');
		search_input.id = 'search_input';
		search_input.type = 'text';
		svg_holder.classList.add('input-group-append');
		search_button.classList.add('btn', 'btn-blue', 'input-lg');
		search_button.id = 'go_search';
		search_section.classList.add('input-group', 'input-group-lg');
		search_section.id = 'search_section';
		form_group.classList.add('form-group')
		search_section.appendChild(search_input);
		search_button.appendChild(search_svg);
		svg_holder.appendChild(search_button);
		search_section.appendChild(svg_holder);
		form_group.appendChild(search_section);
		return form_group;
	}

	add_local_storage(key, data) {
		window.localStorage.removeItem(key);
		window.localStorage.setItem(key, JSON.stringify(data));
	}

	exists_in_local_storage(key) {
		return window.localStorage.getItem(key) !== null;
	}

	search(search_string, max_q) {
		let _that = this;
		if (search_string.length >= 3) {
			_that.options.last_search_string = search_string;
			_that.options.parent.querySelector('#go_to_helpcenter').setAttribute('href', s.url('/help_center', {'help_center_question': search_string}));
			if (typeof max_q === 'undefined') {
				max_q = 5;
			}
			$.post({
				url: s.url('/help_center_process'),
				data: {
					'action': 'search',
					'message': search_string,
					'max_q': max_q,
					'auto': null
				},
				success: function (data) {
					_that.options.widget_go_search.querySelector('img').src = s.url('/images/svg_icons/Icon-search.svg');
					let chat_button_existing = document.querySelector('#hw_chat');
					if (chat_button_existing && !chat_button_existing.classList.contains('not-visible')) {
						chat_button_existing.parentNode.removeChild(chat_button_existing);
					}
					_that.options.parent.querySelector('#answer_holder').innerHTML = '';
					if (data.length > 0) {
						_that.add_local_storage('questions', data);
						let response = _that.generate_question_list(data);
						_that.options.parent.querySelector('#answer_holder').appendChild(response);
						_that.options.answer_holder.classList.remove('d-none');
					} else {
						let paragraph = document.createElement('p');
						let no_results_p = document.createElement('p');
						let strong = document.createElement('strong');
						let ul = document.createElement('ul');
						ul.classList.add('fs-14', 'hw_no_results', 'text-left');
						strong.appendChild(document.createTextNode(s.it('NO_RESULTS', {})));
						paragraph.classList.add('font-size18', 'my-20', 'text-center', 'color-grey-dark');
						no_results_p.classList.add('text-center', 'mb-20');
						no_results_p.appendChild(strong);
						let li1 = document.createElement('li');
						li1.classList.add('color-grey-dark');
						li1.innerText = s.it('NO_RESULTS_1', {});
						ul.appendChild(li1);
						let li2 = document.createElement('li');
						li2.classList.add('color-grey-dark');
						li2.innerText = s.it('NO_RESULTS_2', {});
						ul.appendChild(li2);
						let li3 = document.createElement('li');
						li3.classList.add('color-grey-dark')
						li3.innerText = s.it('NO_RESULTS_3', {});
						ul.appendChild(li3);
						no_results_p.appendChild(ul);
						paragraph.appendChild(no_results_p);
						let splash = _that.getSplash(paragraph, 'no_results');
						_that.options.answer_holder.innerHTML = '';
						_that.options.answer_holder.append(splash);
					}
					_that.options.parent.querySelector('#go_search img').src = s.url('/images/svg_icons/Icon-search.svg');
					_that.bindQuestionEvents();
				}
			});
		} else {
			let paragraph = document.createElement('p');
			let no_results_p = document.createElement('p');
			let strong = document.createElement('strong');
			strong.appendChild(document.createTextNode(s.it('HELP_CENTER_CONTINUE_TYPE', {})));
			paragraph.classList.add('font-size18', 'my-20', 'text-center', 'color-grey-dark');
			no_results_p.classList.add('text-center', 'mb-20');
			no_results_p.appendChild(strong);
			paragraph.appendChild(no_results_p);
			let splash = _that.getSplash(paragraph, 'no_results');
			_that.options.answer_holder.innerHTML = '';
			_that.options.answer_holder.append(splash);
			_that.options.parent.querySelector('#go_search img').src = s.url('/images/svg_icons/Icon-search.svg');
		}
	}

	log_click(question_id) {
		let _that = this;
		_that.options.click_number++;

		if (!_that.exists_in_local_storage('question_id')) {
			try {
				const form_data = new FormData();
				form_data.append('action', 'log');
				form_data.append('from', 'widget');
				form_data.append('message', _that.options.last_search_string);
				form_data.append('question_id', question_id);
				form_data.append('click_number', _that.options.click_number);
				const fetch = s.common.fetcher(
					s.url('help_center_process'),
					{
						method: 'post',
						body: form_data
					}
				);
				console.log('HelpWidget::log_click question(%o) success', question_id);
				return fetch.ready;
			} catch (e) {
				console.error('HelpWidget::log_click question(%o) failed', question_id);
			}
		}
	}

	go_back() {
		let _that = this;
		let questions = JSON.parse(window.localStorage.getItem('questions'));
		let chat_button = document.querySelector('#hw_chat');
		if (chat_button && !chat_button.classList.contains('not-visible')) {
			chat_button.parentNode.removeChild(chat_button);
		}
		if (_that.options.answer_holder) {
			_that.options.widget_form_holder.innerHTML = '';
			let search_section = _that.generate_search_section();
			_that.options.widget_form_holder.appendChild(search_section);
			_that.bindSearchSectionEvents();
			let answer_holder_frame = document.createElement('div');
			answer_holder_frame.id = 'answer_holder';
			let contact_holder_frame = document.createElement('div');
			contact_holder_frame.id = 'contact_holder';
			_that.options.widget_form_holder.appendChild(answer_holder_frame);
			_that.options.widget_form_holder.appendChild(contact_holder_frame);
			let contact_form = _that.options.parent.querySelector('#form_contact').cloneNode(true);
			contact_form.classList.add('d-none')
			contact_form.id = 'form_contact';
			_that.options.widget_form_holder.appendChild(contact_form);
			let help_center_link = document.createElement('a');
			help_center_link.classList.add('btn', 'btn-secondary', 'btn-sm', 'pull-right');
			help_center_link.setAttribute('id', 'go_to_helpcenter')
			help_center_link.href = s.url('/help_center');
			help_center_link.innerText = s.it('MORE_HELP', {});
			_that.options.parent.querySelector('#contact_holder').append(help_center_link);
		}
		let question_list = _that.generate_question_list(questions);
		_that.options.parent.querySelector('#answer_holder').appendChild(question_list);
		_that.bindQuestionEvents();
		if (_that.exists_in_local_storage('question_id')) {
			window.localStorage.removeItem('question_id');
		}
	}

	getSplash(element, use_class) {
		let logo = document.createElement('img');
		logo.src = s.url('/images/logo.svg');
		logo.classList.add('mb-20');
		logo.style.marginLeft = '10%';
		logo.style.marginRight = '10%';
		logo.style.width = '216px';
		let text_div = document.createElement('div');
		text_div.classList.add('d-flex', 'justify-content-center', 'align-items-center', use_class);
		text_div.style.flexDirection = 'column';
		text_div.style.height = '100%';
		text_div.append(logo);
		text_div.append(element);

		return text_div;
	}

	prepare_form() {
		let _that = this;
		_that.options.parent.classList.remove('help_widget');
		_that.options.contact_holder.innerHTML = '';
		_that.options.widget_form_holder.classList.remove('d-none');
		let chat_button_existing = document.querySelector('#hw_chat');
		if (chat_button_existing && !chat_button_existing.classList.contains('not-visible')) {
			chat_button_existing.parentNode.removeChild(chat_button_existing);
		}
		let got_questions = document.createElement('p');
		got_questions.style.opacity = '.5';
		got_questions.classList.add('my-20', 'text-center');
		got_questions.innerHTML = s.it('GOT_QUESTIONS', {});
		let loading_div = _that.getSplash(got_questions, 'loading_content');
		_that.options.answer_holder.innerHTML = '';
		_that.options.answer_holder.appendChild(loading_div);
		$.post({
			url: s.url('/help_center_process'),
			data: {
				'action': 'get_help_widget_settings',
				'message': '',
				'page_name': _that.options.page_name
			},
			success: function (response) {
				if (response.status === true) {
					let data = response.data;
					_that.options.chat_agents_online = data.settings.agent_online;
					if (!_that.exists_in_local_storage('question_id')) {
						_that.add_local_storage('questions', data.questions);
					}
					let help_center_link = document.createElement('a');
					help_center_link.classList.add('btn', 'btn-secondary', 'btn-sm', 'pull-right');
					help_center_link.setAttribute('id', 'go_to_helpcenter')
					help_center_link.href = s.url('/help_center');
					help_center_link.innerText = s.it('MORE_HELP', {});
					_that.options.contact_holder.innerHTML = '';
					_that.options.answer_holder.innerHTML = '';
					_that.options.contact_holder.appendChild(help_center_link);
					let category_options = [];
					if (data.hasOwnProperty('contact_categories')) {
						for (let prop in data.contact_categories) {
							if (data.contact_categories.hasOwnProperty(prop)) {
								if (prop !== '') {
									let category_option = document.createElement('option');
									category_option.value = prop;
									category_option.appendChild(document.createTextNode(data.contact_categories[prop]));
									category_options.push(category_option);
								} else {
									let category_default = document.createElement('option');
									category_default.appendChild(document.createTextNode(s.it('CONTACT_PAGE_CATEGORY', {})));
									category_options.push(category_default);
								}
							}
						}
					}

					if (data.hasOwnProperty('user_data')) {
						for (let user_data in data.user_data) {
							if (data.user_data.hasOwnProperty(user_data)) {
								if (data.user_data[user_data] !== '') {
									_that.options.parent.querySelector('input[name=' + user_data + ']').value = data.user_data[user_data];
								}
							}
						}
					}
					let selector = _that.options.parent.querySelector('#language_id');
					if (data.settings.languages !== null) {
						selector.classList.remove('d-none');
						selector.innerHTML = '';
						Object.values(data.settings.languages).forEach(function (language) {
							let language_option = document.createElement('option');
							language_option.value = language.id;
							language_option.disabled = !!language.disabled;
							language_option.appendChild(document.createTextNode(language.name));
							selector.appendChild(language_option);
						});
					}
					let select =_that.options.parent.querySelector('select[name=category_name]');
					if (select.children.length === 0) {
						category_options.forEach((option) => {
							select.appendChild(option);
						});
					}
					_that.options.answer_holder.innerHTML = '';
					let questions = '';
					if (!_that.exists_in_local_storage('question_id')) {
						questions = _that.generate_question_list(data.questions);
						_that.options.answer_holder.appendChild(questions);
						_that.bindQuestionEvents();
					} else {
						let question_id = JSON.parse(window.localStorage.getItem('question_id'));
						questions = _that.generate_question_list(JSON.parse(window.localStorage.getItem('questions')));
						_that.options.answer_holder.innerHTML = '';
						_that.options.answer_holder.appendChild(questions);
						_that.bindQuestionEvents();
						let questions = _that.options.answer_holder.querySelectorAll('.list-group-item');
						let preselected_question = document.createElement('li');
						questions.forEach(question => {
							if (parseInt(question.dataset.id) === parseInt(question_id)) {
								preselected_question = question;
							}
						});
						preselected_question.click();
					}
				} else {
					console.log('Error : ' + error_message);
					options.answer_holder.append(c);
				}
			},
			error: function (response) {
				console.log('Error : ' + error_message);
				options.answer_holder.append(c);
			}
		});
	}

	close_widget() {
		let _that = this;
		window.localStorage.removeItem('question_id');
		window.localStorage.removeItem('questions');
		clearInterval(_that.idle);
		_that.options.widget_form_holder.classList.add('d-none');
	}

	show_widget() {
		let _that = this;
		_that.prepare_form();
		_that.options.widget_form_holder.classList.remove('d-none');
	}

	createSVG(viewPort, classes, uses) {
		var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.setAttribute('viewBox', viewPort);
		for (var i = 0; i < classes.length; i++) {
			svg.classList.add(classes[i]);
		}
		svg.classList.add('icon');
		svg.innerHTML = '<use xlink:href="' + uses + '"></use>';

		return svg;
	}

	getSpinner() {
		let spinner_element = document.createElement('img');
		spinner_element.src = s.url('/images/spinner.svg');
		return spinner_element;
	}

	static removeSelectedQuestionFromLocalStorage() {
		let question_id = window.localStorage.getItem('question_id');
		console.log(question_id);
		if (question_id) {
			window.localStorage.removeItem('question_id');
		}
	}
}
//# sourceURL=help_center_widget.js
